/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by category`)
};

const es_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por categoría`)
};

const de_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach Kategorie filtern`)
};

const nl_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filteren op categorie`)
};

const fr_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrer par catégorie`)
};

const it_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtra per categoria`)
};

const pt_br2_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por categoria`)
};

const pt_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filtrar por categoria`)
};

const ja_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カテゴリで絞り込む`)
};

const zh_blog_filter_by_category = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按分类筛选`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_filter_by_category = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_filter_by_category(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_filter_by_category", locale)
	if (locale === "en") return en_blog_filter_by_category(inputs)
	if (locale === "es") return es_blog_filter_by_category(inputs)
	if (locale === "de") return de_blog_filter_by_category(inputs)
	if (locale === "nl") return nl_blog_filter_by_category(inputs)
	if (locale === "fr") return fr_blog_filter_by_category(inputs)
	if (locale === "it") return it_blog_filter_by_category(inputs)
	if (locale === "pt-BR") return pt_br2_blog_filter_by_category(inputs)
	if (locale === "pt") return pt_blog_filter_by_category(inputs)
	if (locale === "ja") return ja_blog_filter_by_category(inputs)
	return zh_blog_filter_by_category(inputs)
};